import React, { useState, useEffect } from 'react';
import { soundManager } from '../../utils/soundManager';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    soundManager.play('ui-click', 0.3);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setMenuOpen(false);
    }
  };

  const toggleMenu = () => {
    soundManager.play('ui-click', 0.3);
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo" onClick={() => scrollToSection('hero')}>
          <span className="logo-diamond">◆</span>
          <span className="logo-text">CHRONOS</span>
        </div>

        {/* Desktop Navigation Links */}
        <ul className="navbar-links">
          <li onClick={() => scrollToSection('collections')}>Collections</li>
          <li onClick={() => scrollToSection('craftsmanship')}>Craftsmanship</li>
          <li onClick={() => scrollToSection('heritage')}>Heritage</li>
          <li onClick={() => scrollToSection('contact')}>Contact</li>
        </ul>

        {/* CTA Button */}
        <button 
          className="navbar-cta"
          onClick={() => scrollToSection('reservation')}
        >
          Private Viewing
        </button>

        {/* Mobile Menu Button */}
        <button className="mobile-menu-toggle" onClick={toggleMenu}>
          <span className={`hamburger ${menuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger ${menuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger ${menuOpen ? 'active' : ''}`}></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <ul className="mobile-links">
          <li onClick={() => scrollToSection('collections')}>Collections</li>
          <li onClick={() => scrollToSection('craftsmanship')}>Craftsmanship</li>
          <li onClick={() => scrollToSection('heritage')}>Heritage</li>
          <li onClick={() => scrollToSection('contact')}>Contact</li>
        </ul>
        <button 
          className="mobile-cta"
          onClick={() => scrollToSection('reservation')}
        >
          Private Viewing
        </button>
      </div>
    </nav>
  );
};

export default Navbar;